module.exports = __webpack_public_path__ + "static/media/play.fc056e2b.svg";